import {
  TImportMode,
  TSourceType,
} from './modal-import-sensor-settings.ts';

const sourceType: Record<TSourceType, string> = {
  asset: 'Inne aktywa',
  file: 'Importowanie plików',
};

const ImportMode: Record<TImportMode, string> = {
  migrateMetadata: 'Właściwości sygnału',
  importVirtualSignal: 'Sygnały wirtualne',
};

export default {
  copySensorSettings: 'Importuj wybrane ustawienia czujnika',
  sourceAssetId: 'Źródło aktywów',
  targetAssetId: 'Aktywa docelowe',
  selectDataFormat: {
    placeholder: 'Wybierz format danych',
    selected: 'Format danych',
  },
  selectSource: {
    placeholder: 'Wybierz źródło',
    selected: 'Źródło',
    sentence: 'Importuj ustawienia czujnika z {source} do {target}.',
    selectSourceType: 'Typ źródła',
  },
  selectImportType: {
    placeholder: 'Wybierz typ importu',
    selected: 'Import: {importMode}',
    options: ImportMode,
  },
  sourceType,
  verifyMapping: {
    headline: 'Sprawdź właściwości',
    selectAttributes: 'Właściwości do zaimportowania',
  },
  migrateProgress: {
    headline: 'Importuj ustawienia czujnika',
  },
  errorTable: 'Wystąpiły błędy podczas migracji',
  unknownFileValidationError: 'Nie udało się zweryfikować przesłanego pliku. Dane nie są zgodne z oczekiwaniami.',
  warning: {
    text: 'Zmiany wprowadzone podczas migracji są nieodwracalne. Zaleca się wcześniejsze pobranie kopii zapasowej ustawień czujnika. Kopię tę można później zaimportować w celu przywrócenia aktualnego stanu',
    downloadBackup: 'Pobierz kopię zapasową',
  },
  next: 'Następny',
  prev: 'Poprzedni',
};
